<div [formGroup]="ipiForm">

    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="IPI"
        descricaoAtivo="IPI ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="IPI inativo. Nenhum valor de IPI será calculado nesta natureza de operação."
        emptyStateDescricao="Ative o IPI acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-ipi-tributo-regra-section
        [form]="ipiForm"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasParaCodigoTributo.length === 0"
        [tipoOperacao]="tipoOperacaoValue"
        (personalizar)="abrirEditorFormulas()">
    </app-ipi-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-ipi-tributo-observacoes-section
        [control]="$any(ipiForm.get('observacao'))"
        [variaveis]="ipiForm.get('cstIpi')?.value ? variaveisUnicas : []"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-ipi-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-ipi-tributo-observacoes-fisco-section
        [control]="$any(ipiForm.get('observacaoFisco'))"
        [variaveis]="ipiForm.get('cstIpi')?.value ? variaveisUnicas : []"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-ipi-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-ipi-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [variaveis]="variaveisUnicas"
        [formulasIpi]="formulasIpi"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-ipi-tributo-excecoes-section>

    }

</div>
